import React, { FC } from 'react';
import { Box, MenuMore } from '@dxb-web-ui-framework/design-system';
import { useTranslation } from 'react-i18next';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import {
  GetApp as DownloadTransactionDetailsIcon,
  PictureAsPdf,
  Excel,
} from '@dxb-web-ui-framework/design-system/dist/icons';
import { ECOMMBXLoader } from '../ECOMMBXLoader/ECOMMBXLoader';

type FileDownloadProps = {
  isLoading?: boolean;
  onDownloadClick?: Function;
  shouldShowXlsxDownload?: boolean;
  isDownloadDisabled?: boolean;
};

export enum DownloadTypes {
  XLSX = 'XLSX',
  PDF = 'PDF',
}

const FileDownload: FC<FileDownloadProps> = ({
  isLoading,
  onDownloadClick,
  shouldShowXlsxDownload = true,
  isDownloadDisabled = false,
}) => {
  const { t } = useTranslation();
  const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const pdfConfig = {
    disabled: isDownloadDisabled,
    icon: <PictureAsPdf />,
    label: t('FileDownload.PDF'),
    onClick: onDownloadClick ? () => onDownloadClick(DownloadTypes.PDF) : () => {},
  };

  const excelConfig = {
    disabled: isDownloadDisabled,
    icon: <Excel />,
    label: t('FileDownload.XLSX'),
    onClick: onDownloadClick ? () => onDownloadClick(DownloadTypes.XLSX) : () => {},
  };

  const title = isMobile ? t('FileDownload.ExportOptions') : undefined;

  return (
    <>
      {isLoading && (
        <Box display={'flex'} alignItems={'center'}>
          <ECOMMBXLoader size='small' />
        </Box>
      )}
      {!isLoading && (
        <MenuMore
          menuTitle={title}
          menuMoreAriaLabel={title}
          drawerTitle={title}
          icon={<DownloadTransactionDetailsIcon color='secondary' />}
          items={shouldShowXlsxDownload ? [pdfConfig, excelConfig] : [pdfConfig]}
        />
      )}
    </>
  );
};
export { FileDownload };
